import util from "../utils/Helpers";
function fileUploadHelper(str) {
  for (var i = 0; i < str.length; i++) {
    if (util.badFileCharacter(str[i])) {
      return false;
    }
  }
  if (str.indexOf("/") !== -1 || str.indexOf(":") !== -1 || str[str.length - 1] === ".") {
    return false;
  }

  return true;
}

export default fileUploadHelper;
